import { GearbeltLoader } from '@gearbelt/ui/icons';

export function GbmwRedirectLoader() {
  return (
    <div className="flex h-[100dvh] flex-col items-center justify-center">
      <GearbeltLoader size={50} />
      <div className="text-secondary-text mt-2 text-sm">Opening Gearbelt...</div>
    </div>
  );
}
